import { render, staticRenderFns } from "./SponsorProgram.vue?vue&type=template&id=3017b5a8"
import script from "./SponsorProgram.vue?vue&type=script&lang=js"
export * from "./SponsorProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports